import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)
const state = {
  id: {},
  list: {},
}

const mutations = {
  setNewsId(state, data) {
    state.id = data;
    sessionStorage.setItem('id', JSON.stringify(data))
  },
  setNewsListInfo(state, data) {
    state.list = data;
    sessionStorage.setItem('list', JSON.stringify(data))
  }

}


const getters = {
  getNewsId(state) {

    if(JSON.stringify(state.id) === '{}') {
      state.id = JSON.parse(sessionStorage.getItem('id')) ? JSON.parse(sessionStorage.getItem('id')) : {}
    };
    return state.id;
  },
  getNewsListInfo(state) {
    if(JSON.stringify(state.list) === '{}') {
      state.list = JSON.parse(sessionStorage.getItem('list')) ? JSON.parse(sessionStorage.getItem('list')) : {}
    };
    return state.list;
  }

}


export default  new Vuex.Store({
  state,
  mutations,
  getters,
})



// WEBPACK FOOTER //
// ./src/store.js